// extracted by mini-css-extract-plugin
module.exports = {"content":"qER-F","information":"gntoe","title":"awDwF","info":"rkBS-","divider":"n+Ld1"};